// AUTO GENERATED FILE - Changes WILL be lost.
// el - used as 'el' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Δελτίο",
  "product.last60-row-single": "NBA Τελευταία 60 Ενιαίος Αγώνας",
  "product.sb-english-single": "Αγγλικά Soccerbet Ενιαίος αγώνας",
  "product.sb-italian-single": "Ιταλικό Ποδόσφαιροbet Ενιαίος Αγώνας",
  "product.sb-greek-single": "Ελληνικό Ποδόσφαιροbet Ενιαίος Αγώνας",
  "product.sb-english-league": "Αγγλικό Πρωτάθλημα Ποδοσφαίρου",
  "product.sb-italian-league": "Ιταλικό Πρωτάθλημα Ποδοσφαίρου",
  "product.sb-greek-league": "Ελληνικό ποδόσφαιρο",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "ΣΤΟΙΧΗΜΑΤΙΣΕ",
  "betslip.clear": "ΔΙΑΓΡΑΦΗ ΟΛΩΝ",
  "betslip.clearResult": "ΔΙΑΓΡΑΦΗ",
  "betslip.noSelections": "Προσθέστε επιλογές για να ξεκινήσετε να ποντάρετε",
  "betslip.notLoggedIn": "Συνδεθείτε για να ποντάρετε",
  "betslip.refresh": "Ανανέωση",
  "betslip.totalStake": "ΠΟΝΤΑΡΙΣΜΑ",
  "betslip.noHistoryData": "Δεν υπάρχουν διαθέσιμες πληροφορίες στοιχήματος",
  "betslip.openBets": "Στοιχήματα",
  "betslip.betHistory": "Ιστορικό Στοιχημάτων",
  "betslip.betHistoryWon": "Κερδισμένο",
  "betslip.betHistoryLost": "Χαμένο",
  "loading.loading": "φόρτωση",
  "loading.account": "Φόρτωση λογαριασμού",
  "loading.league": "Φόρτωση Πρωταθλήματος",
  "loading.gameweeks": "Φόρτωση Αγωνιστικής",
  "loading.markets": "Φόρτωση Αγορών",
  "loading.bethistory": "φόρτωση ιστορικού στοιχημάτων",
  "login.loginRequired": "Χρειάζεται Σύνδεση",
  "login.loginToBet": "Συνδεθείτε για να ξεκινησετε να ποντάρετε",
  "navigation.back": "Πίσω",
  "navigation.close": "Κλείσιμο",
  "video.liveStreamAvailable": "Stream Διαθέσιμο",
  "video.logInToWatch": "Ζωντανο Βίντεο Διαθέσιμο Παρακαλούμε Συνδεθείτε",
  "error.error": "Σφάλμα",
  "error.404": "Η Σελίδα δεν βρέθηκε",
  "error.gameLaunchFailed": "Μη Δυνατοτητα φόρτωσης του παιχνιδιού",
  "error.unknownErrorCode": "Άγνωστο σφάλμα {code}",
  "error.minUnitStakeLimitExceeded": "Ελαχιστο Ποντάρισμα {limit}",
  "error.maxUnitStakeLimitExceeded": "Μέγιστο Ποντάρισμα {limit}",
  "error.minTotalStakeLimitExceeded": "Ελαχιστο Ποντάρισμα {limit}",
  "error.maxTotalStakeLimitExceeded": "Μέγιστο Ποντάρισμα {limit}",
  "error.stakeInvalidMultiple": "Το ποντάρισμα πρέπει να είναι πολλαπλάσιο {multiple}",
  "error.notPlaced": "Δεν τοποθετήθηκε",
  "error.wagerDisallowed": "Μη αποδεκτό στοίχημα",
  "error.errorEventIsOff": "Το παιχνίδι έχει ξεκινήσει",
  "wagerType.Singles": "Μονά",
  "wagerType.Doubles": "Διπλά",
  "wagerType.Trebles": "Τριάδα",
  "wagerType.Accumulator": "Παρολί",
  "wagerType.Perm 4-Folds": "Τετράδες",
  "wagerType.Perm 5-Folds": "Πεντάδες",
  "wagerType.Perm 6-Folds": "Εξάδες",
  "wagerType.Perm 7-Folds": "Επτάδες",
  "wagerType.Perm 8-Folds": "Οκτάδες",
  "wagerType.Perm 9-Folds": "Εννιάδες",
  "error.excess_bets": "Μέγιστο {limit} στοιχημάτων στο δελτίο. Παρακαλώ αφαιρέστε μια επιλογή",
  "product.sb-turkish-league": "Τουρκικό Πρωτάθλημα Ποδοσφαίρου",
  "error.minBetslipLimitExceeded": "Ελάχιστο ποσό πονταρίσματος {limit}",
  "error.maxBetslipLimitExceeded": "Μέγιστο ποσό πονταρίσματος {limit}",
  "error.exceededMaxPayout": "Μέγιστο ποσό επιστροφής {limit}",
  "betslip.potentialReturns": "Επιστροφή",
  "betslip.taxDisclaimer": "Τα καθαρά κέρδη φορολογούνται μετά την διευθέτηση του δελτίου. Το ποσό του φόρου θα υπολογιστεί ανάλογα με τα πιθανά κέρδη του δελτίου.",
  "error.maintenanceEnabled": "Οι υπηρεσίες μας δεν ειναι διαθέσιμες λόγω αναβάθμισης.",
  "error.internalError": "Εσωτερικό σφάλμα",
  "error.invalidSession": "Η σύνοδος είναι άκυρη",
  "error.accountDisabled": "Ο λογαριασμός είναι απενεργοποιημένος",
  "error.invalidPlayerID": "Μη έγκυρο αναγνωριστικό παίκτη",
  "error.insufficientBalance": "Ανεπαρκής ισορροπία",
  "error.configError": "Σφάλμα διαμόρφωσης",
  "error.betPlaceFailed": "Απέτυχε να τοποθετήσει το στοίχημα",
  "error.invalidProductID": "Μη έγκυρο αναγνωριστικό προϊόντος",
  "error.playerReachedGamingLimits": "Ο παίκτης έφτασε τα όρια υπεύθυνου παιχνιδιού",
  "error.gameCycleDoesNotExist": "Ο κύκλος του παιχνιδιού δεν υπάρχει",
  "error.betAmountLimitExceeded": "Υπέρβαση του ορίου πιθανών κερδών για μη επαληθευμένους παίκτες",
  "betslip.netStake": "Καθαρό ποντάρισμα",
  "betslip.tax": "Φόρος",
  "error.badReturns": "Οι δυνητικές αποδόσεις είναι χαμηλότερες από το ακαθάριστο μερίδιο",
  "betslip.taxDisclaimerPoland": "Τα κέρδη θα μειωθούν κατά 10% για ποσά άνω των 2.280 PLN.",
  "error.incompatibleVersion": "Μη υποστηριζόμενη έκδοση εφαρμογής. Παρακαλούμε αναβαθμίστε.",
  "product.iihf-row-single": "Παγκόσμιο Πρωτάθλημα IIHF",
  "iihf.fixture.pending": "{home} VS. {away}",
  "iihf.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "ui.returnToPlayer": "Επιστροφή στον παίκτη",
  "abbr.ui.returnToPlayer": "RTP",
  "ui.averageReturnToPlayer": "Ο μέσος όρος RTP για αυτό το παιχνίδι είναι {limit}",
  "error.betslipContainsInvalidOptions": "Το κουπόνι στοιχημάτων περιέχει άκυρες επιλογές με κόκκινο χρώμα",
  "product.sb-scottish-single": "Μονός αγώνας Scottish Soccerbet",
  "product.sb-spanish-single": "Ισπανικό Soccerbet Μονός αγώνας",
  "product.sb-spanish-league": "Ισπανικό πρωτάθλημα Soccerbet",
  "sb-english.team.ARS": "Άρσεναλ",
  "sb-english.team.AST": "Άστον Β.",
  "sb-english.team.BHA": "Μπράϊτον",
  "sb-english.team.BOU": "Μπόρνμουθ",
  "sb-english.team.BUR": "Μπέρνλεϊ",
  "sb-english.team.CHE": "Τσέλσι",
  "sb-english.team.CRY": "Κρίσταλ Π.",
  "sb-english.team.EVE": "Έβέρτον",
  "sb-english.team.LEI": "Λέστερ",
  "sb-english.team.LIV": "Λίβερπουλ",
  "sb-english.team.MNC": "Μάντσεστερ Σ.",
  "sb-english.team.MNU": "Μάντσεστερ Γ.",
  "sb-english.team.NEW": "Νιούκαστλ",
  "sb-english.team.SOU": "Σαουθάμπτον",
  "sb-english.team.TOT": "Τότεναμ",
  "sb-english.team.WAT": "Γουότφορντ",
  "sb-english.team.WHU": "Γουέστ Χαμ",
  "sb-english.team.WOL": "Γουλβς",
  "sb-english.team.NOR": "Νόριτς",
  "sb-english.team.SHU": "Σέφιλντ Γ.",
  "sb-english.team.LEE": "Λιντς",
  "sb-english.team.FUL": "Φούλαμ",
  "sb-english.team.WBA": "Λιντς",
  "sb-greek.team.AEK": "AEK",
  "sb-greek.team.APS": "ΑΠΟΛΛΩΝ ΣΜΥΡΝΗΣ",
  "sb-greek.team.ARI": "ΑΡΗΣ",
  "sb-greek.team.AST": "ΑΣΤΕΡΑΣ ΤΡΙΠΟΛΗΣ",
  "sb-greek.team.ATR": "ΑΤΡΟΜΗΤΟΣ",
  "sb-greek.team.GIA": "ΠΑΣ ΓΙΑΝΝΙΝΑ",
  "sb-greek.team.LEV": "ΛΕΒΑΔΕΙΑΚΟΣ",
  "sb-greek.team.OFI": "ΟΦΗ",
  "sb-greek.team.OLM": "ΟΛΥΜΠΙΑΚΟΣ",
  "sb-greek.team.PTK": "ΠΑΝΑΘΗΝΑΪΚΟΣ",
  "sb-greek.team.PNS": "ΠΑΝΙΩΝΙΟΣ",
  "sb-greek.team.PAO": "ΠΑΟΚ",
  "sb-greek.team.PLT": "ΠΛΑΤΑΝΙΑΣ",
  "sb-greek.team.XAN": "ΞΑΝΘΗ",
  "sb-italian.team.MIL": "Μίλαν",
  "sb-italian.team.ATA": "Αταλάντα",
  "sb-italian.team.BOL": "Μπολόνια",
  "sb-italian.team.BRE": "Μπρέσια",
  "sb-italian.team.CAG": "Κάλιαρι",
  "sb-italian.team.CHI": "Κιέβο",
  "sb-italian.team.FIO": "Φιορεντίνα",
  "sb-italian.team.GEN": "Τζένοα",
  "sb-italian.team.INT": "Ίντερ",
  "sb-italian.team.JUV": "Γιουβέντους",
  "sb-italian.team.LAZ": "Λάτσιο",
  "sb-italian.team.NAP": "Νάπολι",
  "sb-italian.team.ROM": "Ρόμα",
  "sb-italian.team.SAM": "Σαμπτόρια",
  "sb-italian.team.UDI": "Ουντινέζε",
  "sb-italian.team.VER": "Βερόνα",
  "nomorebets": "OΧΙ ΑΛΛΑ ΣΤΟΙΧΗΜΑΤΑ",
  "playtime": "Χρόνος παιχνιδιού",
  "gameId": "Κωδ. Αγώνα",
  "noGames": "Δεν υπάρχουν διαθέσιμα παιχνίδια. Ελέγξτε ξανά σύντομα.",
  "Home": "ΓΗΠΕΔΟΥΧΟΣ",
  "Away": "ΦΙΛΟΞΕΝΟΥΜΕΝΟΣ",
  "Visitor": "ΦΙΛΟΞΕΝΟΥΜΕΝΟΣ",
  "rules": "Κανόνες",
  "soccerbet.gameWeek": "ΑΓΩΝΙΣΤΙΚΗ",
  "soccerbet.noGameWeeks": "Δεν υπάρχουν διαθέσιμες αγωνιστικές. Ελέξτε ξανά αργότερα",
  "soccerbet.league": "Βαθμολογία",
  "soccerbet.table.name": "Ονομα",
  "soccerbet.table.won": "Ν",
  "soccerbet.table.drawn": "Ι",
  "soccerbet.table.lost": "Η",
  "soccerbet.table.points": "Π",
  "abbr.event.Both Teams To Score": "GG/NG (BTTS)",
  "event.Both Teams To Score": "GG/NG (ΝΑ ΣΚΟΡΑΡΟΥΝ ΚΑΙ ΟΙ ΔΥΟ ΟΜΑΔΕΣ)",
  "event.Over / Under": "Over/Under",
  "event.Double Chance": "ΔΙΠΛΗ ΕΥΚΑΙΡΙΑ",
  "event.Match Result": "ΑΠΟΤΕΛΕΣΜΑ",
  "event.Exact Goals": "ΑΚΡΙΒΗΣ ΑΡΙΘΜΟΣ ΓΚΟΛ",
  "event.Correct Score": "ΑΚΡΙΒΕΣ ΣΚΟΡ",
  "event.Match Result Both Score": "ΑΠΟΤΕΛΕΣΜΑ & ΝΑ ΣΚΟΡΑΡΟΥΝ ΚΑΙ ΟΙ 2 ΟΜΑΔΕΣ",
  "event.Result Und/Over 1.5 Total Goals": "ΑΠΟΤΕΛΕΣΜΑ ΚΑΙ Over/Under 1.5 ΓΚΟΛ",
  "event.Result Und/Over 2.5 Total Goals": "ΑΠΟΤΕΛΕΣΜΑ ΚΑΙ Over/Under 2.5 ΓΚΟΛ",
  "event.Under Over 1.5 Total Goals": "Over/Under 1.5 γκολ",
  "event.Under Over 2.5 Total Goals": "Over/Under 2.5 γκολ",
  "event.Under Over 3.5 Total Goals": "Over/Under 3.5 γκολ",
  "event.Under Over 4.5 Total Goals": "Over/Under 4.5 γκολ",
  "event.Total Goals 1 To 2": "ΣΥΝΟΛΙΚΑ ΓΚΟΛ 1-2",
  "event.Total Goals 1 To 3": "ΣΥΝΟΛΙΚΑ ΓΚΟΛ 1-3",
  "event.Total Goals 1 To 4": "ΣΥΝΟΛΙΚΑ ΓΚΟΛ 1-4",
  "event.Total Goals 2 To 3": "ΣΥΝΟΛΙΚΑ ΓΚΟΛ 2-3",
  "event.Total Goals 2 To 4": "ΣΥΝΟΛΙΚΑ ΓΚΟΛ 2-4",
  "event.Under Over 1.5 Home Goals": "Over/Under 1.5 ΓΚΟΛ ΓΗΠΕΔΟΥΧΟΥ",
  "event.Under Over 1.5 Away Goals": "Over/Under 1.5 ΓΚΟΛ ΦΙΛΟΞΕΝΟΥΜΕΝΟΥ",
  "event.Home Team Exact Goals": "ΑΚΡΙΒΗΣ ΑΡΙΘΜΟΣ ΓΚΟΛ ΓΗΠΕΔΟΥΧΟΥ",
  "event.Away Team Exact Goals": "ΑΚΡΙΒΗΣ ΑΡΙΘΜΟΣ ΓΚΟΛ ΦΙΛΟΞΕΝΟΥΜΕΝΟΥ",
  "selection.Yes": "ΝΑΙ",
  "selection.No": "ΟΧΙ",
  "selection.1+G": "1+G",
  "selection.1+Ng": "1+Ng",
  "selection.X+G": "X+G",
  "selection.X+Ng": "X+Ng",
  "selection.2+G": "2+G",
  "selection.2+Ng": "2+Ng",
  "selection.1+Yes": "1+ΝΑΙ",
  "selection.1+No": "1+ΟΧΙ",
  "selection.X+Yes": "X+ΝΑΙ",
  "selection.X+No": "X+ΟΧΙ",
  "selection.2+Yes": "2+ΝΑΙ",
  "selection.2+No": "2+ΟΧΙ",
  "selection.TID_ANY_GOAL_SCORED_YES": "G",
  "selection.TID_ANY_GOAL_SCORED_NO": "Ng",
  "selection.U": "U",
  "selection.O": "O",
  "selection.1+O": "1+O",
  "selection.X+O": "X+O",
  "selection.2+O": "2+O",
  "selection.1+U": "1+U",
  "selection.X+U": "X+U",
  "selection.2+U": "2+U",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "OVER",
  "selection.Under": "UNDER",
  "abbr.sb-english.team.ARS": "ARS",
  "abbr.sb-english.team.AST": "AST",
  "abbr.sb-english.team.BHA": "BHA",
  "abbr.sb-english.team.BOU": "BOU",
  "abbr.sb-english.team.BUR": "BUR",
  "abbr.sb-english.team.CHE": "CHE",
  "abbr.sb-english.team.CRY": "CRY",
  "abbr.sb-english.team.EVE": "EVE",
  "abbr.sb-english.team.LEI": "LEI",
  "abbr.sb-english.team.LIV": "LIV",
  "abbr.sb-english.team.MNC": "MNC",
  "abbr.sb-english.team.MNU": "MNU",
  "abbr.sb-english.team.NEW": "NEW",
  "abbr.sb-english.team.SOU": "SOU",
  "abbr.sb-english.team.TOT": "TOT",
  "abbr.sb-english.team.WAT": "WAT",
  "abbr.sb-english.team.WHU": "WHU",
  "abbr.sb-english.team.WOL": "WOL",
  "abbr.sb-english.team.NOR": "NOR",
  "abbr.sb-english.team.SHU": "SHU",
  "abbr.sb-english.team.LEE": "LEE",
  "abbr.sb-english.team.FUL": "FUL",
  "abbr.sb-english.team.WBA": "WBA",
  "abbr.sb-italian.team.MIL": "MIL",
  "abbr.sb-italian.team.ATA": "ATA",
  "abbr.sb-italian.team.BOL": "BOL",
  "abbr.sb-italian.team.BRE": "BRE",
  "abbr.sb-italian.team.CAG": "CAG",
  "abbr.sb-italian.team.CHI": "CHI",
  "abbr.sb-italian.team.FIO": "FIO",
  "abbr.sb-italian.team.GEN": "GEN",
  "abbr.sb-italian.team.INT": "INT",
  "abbr.sb-italian.team.JUV": "JUV",
  "abbr.sb-italian.team.LAZ": "LAZ",
  "abbr.sb-italian.team.NAP": "NAP",
  "abbr.sb-italian.team.ROM": "ROM",
  "abbr.sb-italian.team.SAM": "SAM",
  "abbr.sb-italian.team.UDI": "UDI",
  "abbr.sb-italian.team.VER": "VER",
  "abbr.sb-greek.team.AEK": "AEK",
  "abbr.sb-greek.team.APS": "ΑΠΟΛ",
  "abbr.sb-greek.team.ARI": "ΑΡΗΣ",
  "abbr.sb-greek.team.AST": "ΑΣΤ",
  "abbr.sb-greek.team.ATR": "ΑΤΡ",
  "abbr.sb-greek.team.GIA": "ΠΑΣ",
  "abbr.sb-greek.team.LEV": "ΛΕΒ",
  "abbr.sb-greek.team.OFI": "ΟΦΗ",
  "abbr.sb-greek.team.OLM": "ΟΛΥ",
  "abbr.sb-greek.team.PTK": "ΠΑΟ",
  "abbr.sb-greek.team.PNS": "ΠΓΣΣ",
  "abbr.sb-greek.team.PAO": "ΠΑΟΚ",
  "abbr.sb-greek.team.PLT": "ΠΛΑΤ",
  "abbr.sb-greek.team.XAN": "ΑΟΞ",
  "sb-turkish.team.AKB": "AKHİSARSPOR",
  "sb-turkish.team.BES": "BEŞIKTAŞ",
  "sb-turkish.team.FEN": "ΦΕΝΕΡΜΠΑΧΤΣΕ",
  "sb-turkish.team.GAL": "ΓΑΛΑΤΑΣΑΡΑΪ",
  "sb-turkish.team.TRA": "ΤΡΑΜΠΖΟΝΣΠΟΡ",
  "sb-turkish.team.ANT": "ΑΝΤΑΛΥΑΣΠΟΡ",
  "sb-turkish.team.GEN": "GENÇLERBİRLİĞİ",
  "sb-turkish.team.KAS": "KASIMPAŞA",
  "sb-turkish.team.BUR": "ΜΠΟΥΡΣΑΣΠΟΡ",
  "sb-turkish.team.KAY": "KAYSERİSPOR",
  "sb-turkish.team.SIV": "SİVASSPOR",
  "sb-turkish.team.IBA": "İSTANBUL BAŞAKŞEHIR",
  "sb-turkish.team.HAT": "HATAYSPOR",
  "sb-turkish.team.ADS": "ΕΝΑ Δ. ΔΕΜΙΡΣΠΟΡ",
  "sb-turkish.team.ALT": "ΑΛΤΑΪ",
  "sb-turkish.team.GAZ": "ΓΚΑΖΙΑΝΤΕΠ",
  "sb-turkish.team.GOZ": "GÖZTEPE",
  "sb-turkish.team.KON": "ΚΟΝΥΑΣΠΟΡ",
  "sb-turkish.team.CRS": "ΝΤΟ. ΡΙΖΕΣΠΟΡ",
  "sb-turkish.team.ALS": "ALANYASPOR",
  "abbr.sb-turkish.team.AKB": "AKB",
  "abbr.sb-turkish.team.BES": "BES",
  "abbr.sb-turkish.team.FEN": "FEN",
  "abbr.sb-turkish.team.GAL": "GAL",
  "abbr.sb-turkish.team.TRA": "TRA",
  "abbr.sb-turkish.team.ANT": "ANT",
  "abbr.sb-turkish.team.GEN": "GEN",
  "abbr.sb-turkish.team.KAS": "KAS",
  "abbr.sb-turkish.team.BUR": "BUR",
  "abbr.sb-turkish.team.KAY": "KAY",
  "abbr.sb-turkish.team.SIV": "SIV",
  "abbr.sb-turkish.team.IBA": "IBA",
  "abbr.sb-turkish.team.HAT": "HAT",
  "abbr.sb-turkish.team.ADS": "ADS",
  "abbr.sb-turkish.team.ALT": "ALT",
  "abbr.sb-turkish.team.GAZ": "GAZ",
  "abbr.sb-turkish.team.GOZ": "GOZ",
  "abbr.sb-turkish.team.KON": "KON",
  "abbr.sb-turkish.team.CRS": "CRS",
  "abbr.sb-turkish.team.ALS": "ALS",
  "sb-english.team.BRE": "Μπρέντφορντ",
  "abbr.sb-english.team.BRE": "ΜΠΡΕ",
  "sb-english.team.NOT": "Νότιγχαμ Φ.",
  "abbr.sb-english.team.NOT": "ΔΕΝ",
  "sb-spanish.team.ALV": "Alaves",
  "sb-spanish.team.ATB": "Αθλητικό Μπιλμπάο",
  "sb-spanish.team.ATM": "Ατλέτικο Μαδρίτης",
  "sb-spanish.team.FCB": "Βαρκελώνη",
  "sb-spanish.team.CAD": "Κάντιθ",
  "sb-spanish.team.CLV": "Celta Vigo",
  "sb-spanish.team.ESP": "Εσπανιόλ",
  "sb-spanish.team.GET": "Getafe",
  "sb-spanish.team.GIR": "Girona",
  "sb-spanish.team.GRA": "Γρανάδα",
  "sb-spanish.team.LAP": "Λας Πάλμας",
  "sb-spanish.team.MAL": "Μαγιόρκα",
  "sb-spanish.team.OSA": "Οσασούνα",
  "sb-spanish.team.RAY": "Rayo Vallecano",
  "sb-spanish.team.BET": "Ρεάλ Μπέτις",
  "sb-spanish.team.MAD": "Ρεάλ Μαδρίτης",
  "sb-spanish.team.SOC": "Πραγματική Scoiedad",
  "sb-spanish.team.SEV": "Σεβίλλη",
  "sb-spanish.team.VAL": "Βαλένθια",
  "sb-spanish.team.VIL": "Βιγιαρεάλ",
  "abbr.sb-spanish.team.ALV": "ALV",
  "abbr.sb-spanish.team.ATB": "ATB",
  "abbr.sb-spanish.team.ATM": "ΑΤΜ",
  "abbr.sb-spanish.team.FCB": "FCB",
  "abbr.sb-spanish.team.CAD": "CAD",
  "abbr.sb-spanish.team.CLV": "CLV",
  "abbr.sb-spanish.team.ESP": "ESP",
  "abbr.sb-spanish.team.GET": "GET",
  "abbr.sb-spanish.team.GIR": "GIR",
  "abbr.sb-spanish.team.GRA": "GRA",
  "abbr.sb-spanish.team.LAP": "LAP",
  "abbr.sb-spanish.team.MAL": "MAL",
  "abbr.sb-spanish.team.OSA": "OSA",
  "abbr.sb-spanish.team.RAY": "RAY",
  "abbr.sb-spanish.team.BET": "BET",
  "abbr.sb-spanish.team.MAD": "MAD",
  "abbr.sb-spanish.team.SOC": "SOC",
  "abbr.sb-spanish.team.SEV": "SEV",
  "abbr.sb-spanish.team.VAL": "VAL",
  "abbr.sb-spanish.team.VIL": "VIL",
  "sb-scottish.team.ABE": "Aberdeen",
  "sb-scottish.team.CEL": "Κέλτικη",
  "sb-scottish.team.DDU": "Dundee United",
  "sb-scottish.team.HEA": "Καρδιές",
  "sb-scottish.team.HIB": "Hiberian",
  "sb-scottish.team.KIL": "Kilmarnock",
  "sb-scottish.team.LIV": "Livingston",
  "sb-scottish.team.MOT": "Motherwell",
  "sb-scottish.team.RAN": "Rangers",
  "sb-scottish.team.STJ": "St Johnstone",
  "sb-scottish.team.STM": "St Mirren",
  "sb-scottish.team.DDE": "Dundee",
  "abbr.sb-scottish.team.ABE": "ABE",
  "abbr.sb-scottish.team.CEL": "CEL",
  "abbr.sb-scottish.team.DDU": "DDU",
  "abbr.sb-scottish.team.HEA": "HEA",
  "abbr.sb-scottish.team.HIB": "HIB",
  "abbr.sb-scottish.team.KIL": "KIL",
  "abbr.sb-scottish.team.LIV": "LIV",
  "abbr.sb-scottish.team.MOT": "MOT",
  "abbr.sb-scottish.team.RAN": "RAN",
  "abbr.sb-scottish.team.STJ": "STJ",
  "abbr.sb-scottish.team.STM": "STM",
  "abbr.sb-scottish.team.DDE": "DDE"
}
